const windowCopy = window;

export default windowCopy;
